import { createContext, useContext } from "./vidstack-D9mvYVIz.js";
//#region src/core/api/media-context.ts
const mediaContext = createContext();
function useMediaContext() {
	return useContext(mediaContext);
}
function useMediaState() {
	return useMediaContext().$state;
}
//#endregion
export { mediaContext, useMediaContext, useMediaState };
